import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Icon } from '.';

//To prevent 'Window is not defined' error
const isBrowser = typeof window !== 'undefined'
const Croppie = isBrowser ? require('croppie') : undefined

class ImageCropField extends Component {
    componentDidMount() {
        this.croppie = new Croppie(this.el, {
            viewport: {
                width: this.props.width,
                height: this.props.height,
                type: this.props.shape
            }
        });
        this.croppie.bind({ url: this.props.imageSrc });
    }

    componentWillUnmount() {
        this.croppie.destroy()
    }

    onResult = e => {
        this.croppie.result("blob").then(blob => {
            this.props.onComplete(blob)
        })
    }

    render() {
        return (
            <div className='image-crop'>
                <div ref={el=> this.el = el} />
                <button type='button' className='btn accept-business-logo under-crop-field pull-right' onClick={this.onResult}>
                  <Icon icon='accept' />
                </button>
            </div>
        )
    }
}

ImageCropField.propTypes = {
    className: PropTypes.string,
    width: PropTypes.number,
    height: PropTypes.number,
    shape: PropTypes.string,
    imageSrc: PropTypes.string,
    onComplete: PropTypes.func.isRequired
};

ImageCropField.defaultProps = {
    width: 200,
    height: 200,
    shape: 'square'
}

export default ImageCropField;


// WEBPACK FOOTER //
// ./src/containers/components/image-crop-field.js